export default __webpack_public_path__ + "static/media/mfp2.bdfec2b7.jpg";